import { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const { clear } = useCart();
  const pollCount = useRef(0);

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          clear();
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) {
          setStatus("failed");
          return;
        }
        pollCount.current++;
        if (pollCount.current > 30) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 3000);
      }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [sid]);

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center p-8" data-testid="success-page">
      <div className="max-w-lg text-center">
        {status === "paid" ? (
          <>
            <CheckCircle size={80} weight="bold" className="text-[#FF3B00] mx-auto" />
            <h1 className="font-display text-6xl uppercase mt-6">Merci !</h1>
            <p className="mt-4 text-white/70">Votre paiement a été confirmé. Vous recevrez un email de confirmation sous peu.</p>
            <div className="mt-8 flex gap-3 justify-center">
              <Link to="/commandes" className="px-6 py-3 bg-[#FF3B00] text-white uppercase tracking-widest">Mes commandes</Link>
              <Link to="/catalogue" className="px-6 py-3 border border-white/20 hover:border-white uppercase tracking-widest">Continuer</Link>
            </div>
          </>
        ) : status === "polling" ? (
          <>
            <div className="font-display text-6xl uppercase animate-pulse">Confirmation...</div>
            <p className="mt-4 text-white/60">Nous vérifions votre paiement.</p>
          </>
        ) : (
          <>
            <XCircle size={80} weight="bold" className="text-red-500 mx-auto" />
            <h1 className="font-display text-6xl uppercase mt-6">Échec</h1>
            <p className="mt-4 text-white/70">Nous n'avons pas pu confirmer votre paiement.</p>
            <Link to="/panier" className="mt-6 inline-block px-6 py-3 bg-[#FF3B00] text-white uppercase tracking-widest">Retour au panier</Link>
          </>
        )}
      </div>
    </div>
  );
}
